import { DefaultButton } from '@fluentui/react/lib/Button';
import * as React from 'react';
import {
    Detail,
    TextDetailPart,
    CustomDetailPart,
    isCustomDetailPart,
    isTextDetailPart,
    ButtonDetailPart,
    isButtonDetailPart,
} from '../schema/DetailPart';
import { CharmControl, CharmControlColorPattern, CharmControlProps } from 'owa-charmcontrol';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getPalette } from 'owa-theme';

const styles = require('./AgendaEventDetailViews.scss');
const classNames = require('classnames');

export const DetailPartView = function DetailPartView(detailPart: Detail) {
    if (isTextDetailPart(detailPart)) {
        return <TextDetailPartView {...detailPart} />;
    }
    if (isCustomDetailPart(detailPart)) {
        return <CustomDetailPartView {...detailPart} />;
    }
    if (isButtonDetailPart(detailPart)) {
        return <ButtonPartView {...detailPart} />;
    }
    return null;
};

const TextDetailPartView = function TextDetailPartView(props: TextDetailPart) {
    const { colorScheme, getTextProps, className, getCharmControllProps } = props;
    return (
        <div className={classNames(styles.detail, className)}>
            {getCharmControllProps && renderCharm(getCharmControllProps(), colorScheme)}
            <div
                style={{
                    color: colorScheme ? colorScheme.accessibleText.msColorWhiteBackground : null,
                }}
                title={getTextProps().text}
                className={classNames(styles.detailText, getTextProps().className)}>
                {getTextProps().text}
            </div>
        </div>
    );
};

const renderCharm = function renderCharm(
    charmControlProps: CharmControlProps,
    colorScheme: ColorScheme
): JSX.Element {
    /** if a color scheme was passed with the text detail, use this to get the icon color props */
    const charmControlColorProps = colorScheme
        ? {
              colorPattern: CharmControlColorPattern.Normal,
              calPrimary: colorScheme.accessibleText.msColorWhiteBackground, // looks really weird in dark mode if charm is different color than text
              calDark: colorScheme.calDark,
              calDarkAlt: colorScheme.calDarkAlt,
              textColor: colorScheme.accessibleText.msColorWhiteBackground,
          }
        : {
              colorPattern: CharmControlColorPattern.Normal,
              calPrimary: getPalette().neutralPrimary,
              textColor: getPalette().neutralPrimary,
          };

    return <CharmControl colorProps={charmControlColorProps} {...charmControlProps} />;
};

const CustomDetailPartView = function CustomDetailPartView(props: CustomDetailPart) {
    return props.renderCustomDetailPart ? props.renderCustomDetailPart() : null;
};

export const ButtonPartView = function ButtonPartView(props: ButtonDetailPart) {
    return <DefaultButton {...props.buttonProps} />;
};
